module.exports = __webpack_public_path__ + "static/media/ArrowLeftNavyBlue.d15f0163.svg";